import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable for the current user's privilege level.
 * - isAdmin: account-level administrator (account_users.role).
 * - isSuperAdmin: platform Super Admin (users.type === 'SuperAdmin'). This is ORTHOGONAL to role —
 *   a super admin is usually also an account administrator, so role can't distinguish them; every
 *   super-admin-only gate must key off `type`, not role.
 * @returns {{ isAdmin: import('vue').ComputedRef<boolean>, isSuperAdmin: import('vue').ComputedRef<boolean> }}
 */
export function useAdmin() {
  const getters = useStoreGetters();

  const currentUserRole = computed(() => getters.getCurrentRole.value);
  const isAdmin = computed(() => currentUserRole.value === 'administrator');
  const isSuperAdmin = computed(
    () => getters.getCurrentUser.value?.type === 'SuperAdmin'
  );

  return {
    isAdmin,
    isSuperAdmin,
  };
}
